/* Shared site-wide footer, used by every page.
   Links point to real page files and (for in-page anchors) are scoped to home. */

(function () {
  const BASE = window.MM_BASE || './';
  const LOGO_V = '';

  function SharedFooter() {
    const year = new Date().getFullYear();
    return (
      <footer className="mm-footer" aria-label="Site footer">
        <div className="mm-section-inner mm-footer-inner">
          <div className="mm-footer-top">
            <div className="mm-footer-brand">
              <img className="mm-footer-logo" src={`${BASE}logo/movie-minder-topnav.svg${LOGO_V}`} alt="Movie Minder" />
              <p className="mm-footer-tagline">Turn today&rsquo;s trailer into<br />tomorrow&rsquo;s ticket.</p>
            </div>
            <nav className="mm-footer-nav" aria-label="Footer links">
              <div className="mm-footer-col">
                <h3 className="mm-footer-h">Pages</h3>
                <a href="index.html">Home</a>
                <a href="platform.html">Platform</a>
                <a href="about.html">About</a>
              </div>
              <div className="mm-footer-col">
                <h3 className="mm-footer-h">Explore</h3>
                <a href="index.html#how">How it works</a>
                <a href="index.html#proof">Results</a>
                <a href="index.html#faq">FAQ</a>
              </div>
              <div className="mm-footer-col">
                <h3 className="mm-footer-h">Contact</h3>
                <a href="mailto:hello@3xmt.ai">hello@3xmt.ai</a>
                <a href="privacy.html">Privacy policy</a>
                <a href="terms.html">Terms</a>
              </div>
            </nav>
          </div>
          <div className="mm-footer-bottom">
            <div className="mm-footer-legal">
              <span>&copy; {year} Movie Minder.</span>
              <span className="mm-footer-parent">A <a href="https://3xmtechnologies.com" target="_blank" rel="noopener noreferrer">3XM Technologies Inc.</a> product</span>
            </div>
            <div className="mm-footer-social" aria-label="Social links">
              <a href="#" aria-label="X">X</a>
            </div>
          </div>
        </div>
      </footer>
    );
  }

  window.SharedFooter = SharedFooter;
})();
